import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();
  const [submitted, setSubmitted] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    // const templateParams = {
    //   from_name: form.current[0].value,
    //   from_email: form.current[1].value,
    //   subject: form.current[2].value,
    //   message: form.current[3].value,
    // };

    // console.log("templateParams:- " + templateParams.toString());
    // // send email using emailjs library
    // emailjs
    //   .sendForm("service_fjomb95", "template_yritgro", templateParams, {
    //     publicKey: "TxwqimuhJOoGDRLY0",
    //   })
    //   .then(
    //     () => {
    //       console.log("SUCCESS!");
    //     },
    //     (error) => {
    //       console.log("FAILED...", error.text);
    //     }
    //   );

    //   console.log("Form Current content:- "+form.current.toString());
    // show popup after some time interval
    setTimeout(() => {
      setSubmitted(true);
    }, 100);
    form.current.reset();
  };

  const handleClose = () => {
    setSubmitted(false);
  };

  return (
    <section id="contact" className="pb-16 pt-16 justify-center flex">
      <div className="container">
        <div className="text-smallTextColor text-[2rem] font-[500] text-center md:text-left">
          Get in touch
        </div>
        <div className="md:flex justify-between items-center md:space-x-6 lg:mx-0 sm:mx-[10px]">
          <div className="w-full md:w-1/2">
            <iframe
              title="Our Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7565.064454658508!2d73.89949714923368!3d18.550028997042773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c110906790c5%3A0x56612d8536b59a72!2sKalyani%20Nagar%2C%20Pune%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1710659035110!5m2!1sen!2sin"
              width="100%"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-[5px] mb-8 md:mb-0"
            ></iframe>
          </div>

          {/* contact form */}
          <div className="w-full md:w-1/2 lg:flex items-center bg-indigo-100 px-4 lg:px-8 py-8 rounded-[5px]">
            {submitted ? (
              <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
                <div className="bg-white p-8 rounded-md text-center relative">
                  <button
                    onClick={handleClose}
                    className="absolute top-0 right-0 m-2 text-gray-600 hover:text-gray-800 focus:outline-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                  <h2 className="text-2xl font-bold mb-4">
                    Thank you for your submission!
                  </h2>
                  <p className="text-lg">We'll get back to you shortly.</p>
                </div>
              </div>
            ) : (
              ""
            )}
            <form className="w-full" ref={form} onSubmit={sendEmail}>
              <div className="mb-5">
                <input
                  type="text"
                  placeholder="Enter your name"
                  className="w-full p-3 focus:outline-none rounded-[5px]"
                />
              </div>
              <div className="mb-5">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="w-full p-3 focus:outline-none rounded-[5px]"
                />
              </div>
              <div className="mb-5">
                <input
                  type="text"
                  placeholder="Subject"
                  className="w-full p-3 focus:outline-none rounded-[5px]"
                />
              </div>
              <div className="mb-5">
                <textarea
                  type="text"
                  rows={3}
                  placeholder="Enter your message"
                  className="w-full p-3 focus:outline-none rounded-[5px]"
                ></textarea>
              </div>
              <button className="w-full p-3 focus:outline-none rounded-[5px] bg-smallTextColor text-white hover:bg-headingColor text-center ease-linear duration-150">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
